var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 16 16",
    height: "16px",
    id: "Layer_1",
    viewBox: "0 0 24 24",
    width: "24px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,9.8h-3c-0.3,0-0.5,0.2-0.5,0.5v2.4c0,0.3,0.2,0.5,0.5,0.5S21,13,21,12.7v-1.9h2.1v12.3h-1h-1v-6.9 c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5v6.9h-0.9v-9.7c0-0.3-0.2-0.5-0.5-0.5h-3c-0.3,0-0.5,0.2-0.5,0.5v9.7h-0.9v-6.4 c0-0.3-0.2-0.5-0.5-0.5h-3c-0.3,0-0.5,0.2-0.5,0.5v6.4H9.4v-3.7c0-0.3-0.2-0.5-0.5-0.5h-3c-0.3,0-0.5,0.2-0.5,0.5v3.7h-4 c-0.3,0-0.5-0.2-0.5-0.5V1.4c0-0.3,0.2-0.5,0.5-0.5h12.1V4c0,0.8,0.6,1.4,1.4,1.4H18v5.8c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V5 c0-0.1,0-0.2-0.1-0.3l-4.5-4.5C14.2,0,14.1,0,14,0H1.4C0.6,0,0,0.6,0,1.4v21.2C0,23.4,0.6,24,1.4,24h22.1c0.3,0,0.5-0.2,0.5-0.5 V10.3C24,10,23.8,9.8,23.5,9.8z M14.4,1.6l2.9,2.9h-2.4c-0.3,0-0.5-0.2-0.5-0.5V1.6z M8.4,23.1h-2v-3.3h2.1v3.3H8.4z M13.3,23.1 h-2.1v-6h2.1C13.3,17.1,13.3,23.1,13.3,23.1z M18.2,23.1h-2.1v-9.2h2.1V23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,14.8c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3s0-0.4,0-0.4c-0.1-0.1-0.2-0.1-0.3-0.1 s-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3s0.1,0.2,0.1,0.3C20.3,14.7,20.4,14.8,20.5,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,2.6C6.6,2.6,6.4,2.8,6.4,3v0.8C4.2,4.1,2.5,5.9,2.5,8.2c0,2.4,1.9,4.3,4.3,4.3c2.2,0,4.1-1.7,4.3-3.8H12 c0.3,0,0.5-0.2,0.5-0.5C12.4,5.1,9.9,2.6,6.8,2.6z M6.8,11.5C5,11.5,3.5,10,3.5,8.2c0-1.7,1.3-3.1,2.9-3.3v3.3 c0,0.3,0.2,0.5,0.5,0.5h3.3C9.9,10.3,8.5,11.5,6.8,11.5z M7.3,7.7L7.3,7.7V3.5c2.2,0.2,3.9,2,4.2,4.2H7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,14.3c0-0.3-0.2-0.5-0.5-0.5H3c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h9C12.2,14.7,12.4,14.5,12.4,14.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,16.1c-0.3,0-0.5,0.2-0.5,0.5C2.5,16.8,2.7,17,3,17h3c0.3,0,0.5-0.2,0.5-0.5S6.3,16,6,16H3V16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,16.2c-0.1,0.1-0.1,0.2-0.1,0.3s0,0.2,0.1,0.3C8.1,16.9,8.2,17,8.3,17s0.2-0.1,0.3-0.1 c0.1-0.1,0.1-0.2,0.1-0.3s-0.1-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1C8.2,16.1,8.1,16.1,8,16.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.49fbbc967a5007b3b35af2d22fd46429.svg";
export { ForwardRef as ReactComponent };